import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <circle r="2.47917" transform="matrix(-1 0 0 1 5.99999 5.99992)" fill={color} stroke={color} strokeWidth="0.875"/>
        <path d="M6 0.458252V1.91659" stroke={color} strokeWidth="0.875" strokeLinecap="round"/>
        <path d="M6.00003 10.0831V11.5415" stroke={color} strokeWidth="0.875" strokeLinecap="round"/>
        <path d="M0.458313 6L1.91665 6" stroke={color} strokeWidth="0.875" strokeLinecap="round"/>
        <path d="M10.0833 6.00012L11.5416 6.00012" stroke={color} strokeWidth="0.875" strokeLinecap="round"/>
        <path d="M9.91809 2.08142L9.0987 2.90081" stroke={color} strokeWidth="0.875" strokeLinecap="round"/>
        <path d="M2.89175 9.10791L2.08116 9.91851" stroke={color} strokeWidth="0.875" strokeLinecap="round"/>
        <path d="M2.0813 2.08142L2.90069 2.90081" stroke={color} strokeWidth="0.875" strokeLinecap="round"/>
        <path d="M9.10779 9.10779L9.91838 9.91838" stroke={color} strokeWidth="0.875" strokeLinecap="round"/>
    </svg>
)

export default class IconDay extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
